// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__4YWfU","large":"styles_large__3TeFE"};